// 언어력 문제 재료 — 어휘(유의어·반의어·뜻), 사자성어, 읽기 글. 모두 새로 쓴 것 (실제 검사 문항 아님).
// 낱말: [낱말, 뜻, 유의어(쉼표), 반의어(쉼표), 난이도 1~3, 묶음]
// 묶음 = 뜻이 가까워 서로의 오답 보기로 쓰면 정답이 둘이 될 수 있는 낱말들 (예: 승인↔거부 와 일축=거절).
export type WordRow = [string, string, string, string, number, string?];

export const WORDS: WordRow[] = [
  ['증가', '양이나 수가 늘어남', '증대', '감소', 1, 'grow'],
  ['확대', '모양이나 규모를 더 크게 함', '확장', '축소', 1, 'grow'],
  ['연장', '시간이나 길이를 본래보다 늘림', '', '단축', 1, 'grow'],
  ['팽창', '부풀어서 부피가 커짐', '', '수축', 1, 'grow'],
  ['상승', '낮은 데서 위로 올라감', '', '하강', 1, 'grow'],
  ['확충', '늘리고 넓혀 충실하게 함', '확장', '', 2, 'grow'],
  ['낙관', '앞으로의 일이 잘될 것이라고 봄', '', '비관', 1],
  ['근면', '부지런히 일하며 힘씀', '', '나태', 1],
  ['겸손', '남을 높이고 자기를 낮추는 태도가 있음', '겸허', '교만', 1],
  ['절약', '함부로 쓰지 않고 꼭 필요한 데만 써서 아낌', '검약', '낭비', 1],
  ['흑자', '수입이 지출보다 많아 이익이 생기는 일', '', '적자', 1, 'econ'],
  ['우연', '아무런 인과 관계 없이 뜻하지 않게 일어난 일', '', '필연', 1],
  ['직접', '중간에 매개나 거리 없이 바로 연결되는 관계', '', '간접', 1],
  ['다수', '수효가 많음', '', '소수', 1],
  ['분산', '갈라져 흩어짐', '', '집중', 1, 'gather'],
  ['집합', '사람들을 한곳으로 모으거나 모임', '집결', '해산', 2, 'gather'],
  ['수렴', '여럿으로 나뉜 의견이나 생각을 하나로 모아 정리함', '집약', '발산', 3, 'gather'],
  ['가해', '다른 사람의 생명이나 신체, 재산 따위에 해를 끼침', '', '피해', 1],
  ['고용', '삯을 주고 사람을 부림', '', '해고', 1],
  ['사실', '실제로 있었던 일이나 현재에 있는 일', '실제', '허구', 1, 'truth'],
  ['허위', '진실이 아닌 것을 진실인 것처럼 꾸민 것', '거짓', '진실', 2, 'truth'],
  ['허용', '허락하여 너그럽게 받아들임', '허락', '금지', 1, 'allow'],
  ['결점', '잘못되거나 부족하여 완전하지 못한 점', '단점,흠', '장점', 1, 'fault'],
  ['공헌', '힘을 써 이바지함', '기여', '', 1],
  ['일조', '얼마간의 도움이 됨', '기여', '', 3],
  ['근심', '해결되지 않은 일 때문에 속을 태우거나 우울해함', '걱정', '', 1, 'worry'],
  ['우려', '근심하거나 걱정함', '염려', '안심', 2, 'worry'],
  ['모방', '다른 것을 본뜨거나 본받음', '흉내', '창조', 1, 'create'],
  ['창출', '전에 없던 것을 처음으로 생각하여 지어내거나 만들어 냄', '창조', '', 2, 'create'],
  ['고안', '연구하여 새로운 안을 생각해 냄', '창안', '', 2, 'create'],
  ['착안', '어떤 문제를 해결하기 위한 실마리를 잡음', '착상', '', 3, 'create'],
  ['보존', '잘 보호하고 간수하여 남김', '보전', '파괴', 1, 'keep'],
  ['훼손', '헐거나 깨뜨려 못 쓰게 만듦', '파손', '', 2, 'keep'],
  ['착수', '어떤 일에 손을 대어 시작함', '개시', '', 1],
  ['철회', '이미 제출하였던 것이나 주장하였던 것을 도로 거두어들임', '취소', '', 1],
  ['해소', '어려운 일이나 문제가 되는 상태를 해결하여 없애 버림', '해결', '', 1, 'solve'],
  ['파악', '어떤 대상의 내용이나 본질을 확실하게 이해하여 앎', '이해', '', 1, 'know'],
  ['입증', '어떤 증거 따위를 내세워 증명함', '증명', '', 1],
  ['장려', '좋은 일에 힘쓰도록 북돋아 줌', '권장', '', 1, 'urge'],
  ['종용', '잘 설득하고 달래어 권함', '권유', '', 3, 'urge'],
  ['조장', '바람직하지 않은 일을 더 심해지도록 부추김', '', '', 3, 'urge'],
  ['혼잡', '여럿이 한데 뒤섞이어 어수선함', '', '한산', 1, 'order'],
  ['순종', '순순히 따름', '복종', '반항', 1, 'obey'],
  ['정숙', '조용하고 엄숙함', '', '소란', 2, 'order'],
  ['질서', '혼란 없이 순조롭게 이루어지게 하는 사물의 순서나 차례', '', '혼란', 1, 'order'],
  ['개방', '문이나 어떠한 공간 따위를 열어 자유롭게 드나들고 이용하게 함', '', '폐쇄', 1, 'allow'],
  ['유능', '어떤 일을 하는 능력이 있음', '', '무능', 1, 'skill'],
  ['승인', '어떤 사실을 마땅하다고 받아들임', '인정', '거부', 2, 'accept'],
  ['수긍', '옳다고 인정함', '납득', '', 2, 'accept'],
  ['일축', '제안이나 부탁 따위를 단번에 거절하거나 물리침', '거절', '', 3, 'accept'],
  ['원인', '어떤 사물이나 상태를 변화시키거나 일으키는 근본이 된 일', '', '결과', 1],
  ['밀물', '바닷물이 육지 쪽으로 밀려 들어오는 것', '', '썰물', 1],
  ['입금', '돈을 들여놓거나 넣어 줌', '', '출금', 1],
  ['진보', '정도나 수준이 나아지거나 높아짐', '발전', '퇴보', 1, 'progress'],
  ['진척', '일이 목적한 방향대로 진행되어 감', '진전', '', 2, 'progress'],
  ['정체', '사물이 발전하거나 나아가지 못하고 한자리에 머물러 그침', '침체', '', 2, 'progress'],
  ['쇠퇴', '기세나 상태가 쇠하여 전보다 못하여 감', '쇠락', '번영', 2, 'progress'],
  ['호전', '병의 증세나 일의 형세가 나아짐', '', '악화', 2, 'progress'],
  ['신중', '매우 조심스러움', '', '경솔', 1],
  ['역량', '어떤 일을 해낼 수 있는 힘', '능력', '', 1, 'skill'],
  ['실마리', '일이나 사건을 풀어 나갈 수 있는 첫머리', '단서', '', 1],
  ['객관', '자기와의 관계에서 벗어나 제삼자의 입장에서 사물을 보거나 생각함', '', '주관', 2],
  ['추상', '여러 사물에서 공통되는 성질을 뽑아내어 파악함', '', '구체', 2],
  ['분석', '복잡한 것을 풀어서 개별적인 요소나 성질로 나눔', '', '종합', 2],
  ['능동', '스스로 내켜서 움직이거나 작용함', '', '수동', 2, 'active'],
  ['적극', '대상에 대하여 긍정적이고 능동적으로 활동함', '', '소극', 2, 'active'],
  ['권리', '어떤 일을 행하거나 남에게 요구할 수 있는 정당한 자격', '', '의무', 2],
  ['호황', '경제 활동 전반이 활기를 띠는 상태', '활황', '불황', 2, 'econ'],
  ['가결', '회의에서 제출된 안건을 합당하다고 결정함', '', '부결', 2],
  ['보편', '모든 것에 두루 미치거나 통함', '일반', '특수', 2],
  ['진부', '사상, 표현, 행동 따위가 낡아서 새롭지 못함', '상투', '참신', 2],
  ['모호', '말이나 태도가 흐리터분하여 분명하지 않음', '애매', '명확', 2, 'clear'],
  ['자명', '설명하거나 증명하지 아니하여도 저절로 알 만큼 명백함', '명백', '', 2, 'clear'],
  ['간과', '큰 관심 없이 대강 보아 넘김', '등한시', '', 2, 'neglect'],
  ['경시', '대수롭지 않게 보거나 업신여김', '', '중시', 2, 'neglect'],
  ['묵인', '모르는 체하고 하려는 대로 내버려 둠으로써 슬며시 인정함', '묵과', '', 2, 'neglect'],
  ['방치', '내버려 둠', '방임', '', 2, 'neglect'],
  ['지양', '더 높은 단계로 오르기 위하여 어떠한 것을 하지 아니함', '', '지향', 3],
  ['희박', '기체나 액체 따위의 밀도나 농도가 낮거나 엷음', '', '농후', 3],
  ['고의', '일부러 하는 생각이나 태도', '', '과실', 3, 'fault'],
  ['미숙', '일 따위에 익숙하지 못하여 서투름', '', '능숙', 2, 'skill'],
  ['과묵', '말이 적고 침착함', '', '다변', 3],
  ['엄격', '말, 태도, 규칙 따위가 매우 엄하고 철저함', '', '관대', 2, 'lenient'],
  ['대범', '성격이나 태도가 사소한 것에 얽매이지 아니하고 너그러움', '', '소심', 2, 'lenient'],
  ['결핍', '있어야 할 것이 없어지거나 모자람', '부족', '충족', 2, 'lack'],
  ['미흡', '아직 흡족하지 못하거나 만족스럽지 아니함', '부족', '흡족', 2, 'lack'],
  ['은폐', '덮어 감추거나 가리어 숨김', '은닉', '폭로', 3, 'tell'],
  ['할인', '일정한 값에서 얼마를 뺌', '', '할증', 2],
  ['균등', '고르고 가지런하여 차별이 없음', '', '차등', 2],
  ['영구', '어떤 상태가 시간상으로 끝없이 이어짐', '영원', '일시', 2, 'time'],
  ['이완', '바짝 조였던 정신이 풀려 늦추어짐', '', '긴장', 2, 'relax'],
  ['해이', '긴장이나 규율 따위가 풀려 마음이 느슨함', '', '', 3, 'relax'],
  ['흥분', '어떤 자극을 받아 감정이 북받쳐 일어남', '', '진정', 2, 'relax'],
  ['수요', '어떤 재화나 용역을 일정한 가격으로 사려고 하는 욕구', '', '공급', 2],
  ['채권', '빌려준 돈 따위를 받아 낼 수 있는 권리', '', '채무', 3],
  ['귀감', '거울로 삼아 본받을 만한 모범', '본보기', '', 2],
  ['과오', '부주의나 태만 따위에서 비롯된 잘못이나 허물', '잘못', '', 2, 'fault'],
  ['독촉', '일이나 행동을 빨리하도록 재촉함', '재촉', '', 2],
  ['모색', '일이나 사건 따위를 해결할 수 있는 방법이나 실마리를 더듬어 찾음', '탐색', '', 2],
  ['미연', '어떤 일이 아직 그렇게 되지 않은 때', '', '', 2],
  ['배척', '따돌리거나 거부하여 밀어 내침', '배제', '', 2, 'accept'],
  ['보완', '모자라거나 부족한 것을 보충하여 완전하게 함', '보충', '', 2],
  ['부응', '어떤 요구나 기대 따위에 좇아서 응함', '호응', '', 2, 'agree'],
  ['상기', '지난 일을 돌이켜 생각해 냄', '회상', '', 2],
  ['상충', '맞지 아니하고 서로 어긋남', '충돌', '', 2],
  ['속박', '어떤 행위나 권리를 자유롭게 하지 못하도록 얽어매거나 제한함', '구속', '해방', 2],
  ['순응', '환경이나 변화에 적응하여 익숙해지거나 따름', '적응', '', 2, 'obey'],
  ['시사', '어떤 것을 미리 간접적으로 표현해 줌', '암시', '', 2],
  ['쇄신', '그릇된 것이나 묵은 것을 버리고 새롭게 함', '혁신', '', 2],
  ['엄수', '규칙이나 명령 따위를 어김없이 지킴', '준수', '위반', 2],
  ['연계', '어떤 일이나 사람과 관련하여 관계를 맺음', '연결', '', 2],
  ['완화', '긴장된 상태나 급박한 것을 느슨하게 함', '경감', '강화', 2, 'relax'],
  ['용이', '어렵지 아니하고 매우 쉬움', '수월', '', 2],
  ['유보', '어떤 일을 당장 처리하지 아니하고 나중으로 미루어 둠', '보류', '', 2],
  ['유추', '같은 종류의 것이나 비슷한 것에 기초하여 다른 사물을 미루어 추측함', '추리', '', 2, 'infer'],
  ['귀납', '개별적인 사실에서 일반적인 원리를 이끌어 냄', '', '연역', 3, 'infer'],
  ['이행', '실제로 행함', '실행', '', 2],
  ['인지', '어떤 사실을 인정하여 앎', '인식', '', 2, 'know'],
  ['저해', '막아서 못 하도록 해침', '방해', '촉진', 2, 'urge'],
  ['절충', '서로 다른 의견 따위를 알맞게 조절하여 서로 잘 어울리게 함', '타협', '', 2],
  ['제고', '수준이나 정도 따위를 끌어올림', '향상', '', 2, 'progress'],
  ['조달', '자금이나 물자 따위를 대어 줌', '마련', '', 2],
  ['채택', '작품, 의견, 제도 따위를 골라서 다루거나 뽑아 씀', '선정', '', 2],
  ['추이', '일이나 형편이 시간의 경과에 따라 변하여 나감', '추세', '', 2],
  ['취약', '무르고 약함', '허약', '', 2],
  ['침해', '침범하여 해를 끼침', '침범', '', 2],
  ['타당', '일의 이치로 보아 옳음', '합당', '', 2],
  ['편견', '공정하지 못하고 한쪽으로 치우친 생각', '선입견', '', 2, 'bias'],
  ['편중', '한쪽으로 치우침', '편향', '', 2, 'bias'],
  ['포괄', '일정한 대상이나 현상 따위를 어떤 범위 안에 모두 끌어넣음', '망라', '', 2],
  ['회피', '꾀를 부려 마땅히 져야 할 책임을 지지 아니함', '기피', '', 2],
  ['초래', '일의 결과로서 어떤 현상을 생겨나게 함', '야기', '', 2],
  ['쟁점', '서로 다투는 중심이 되는 점', '논점', '', 2],
  ['각별', '어떤 일에 대한 마음가짐이나 자세 따위가 유달리 특별함', '특별', '', 2],
  ['비범', '보통 수준보다 훨씬 뛰어남', '탁월', '평범', 2, 'skill'],
  ['낙담', '바라던 일이 뜻대로 되지 아니하여 마음이 몹시 상함', '실망', '', 2],
  ['효율', '들인 노력과 얻은 결과의 비율', '능률', '', 2],
  ['이견', '어떤 의견에 대한 다른 의견', '이의', '', 2, 'agree'],
  ['동조', '남의 주장에 자기의 의견을 일치시키거나 보조를 맞춤', '찬동', '반대', 2, 'agree'],
  ['정밀', '아주 정교하고 치밀하여 빈틈이 없고 자세함', '정교', '조잡', 2],
  ['생성', '사물이 생겨남', '', '소멸', 2, 'keep'],
  ['절대', '비교하거나 상대될 만한 것이 없음', '', '상대', 2],
  ['점진', '조금씩 앞으로 나아감', '', '급진', 2],
  ['문명', '인류가 이룩한 물질적·기술적·사회 구조적인 발전', '', '야만', 2],
  ['함양', '능력이나 품성을 길러 쌓거나 갖춤', '배양', '', 3],
  ['타개', '매우 어렵거나 막힌 일을 잘 처리하여 해결의 길을 엶', '극복', '', 3, 'solve'],
  ['토로', '마음에 있는 것을 죄다 드러내어서 말함', '고백', '', 3, 'tell'],
  ['피력', '생각하는 것을 털어놓고 말함', '개진', '', 3, 'tell'],
  ['와해', '조직이나 계획 따위가 산산이 무너지고 흩어짐', '붕괴', '', 3, 'keep'],
  ['사려', '여러 가지 일에 대하여 깊게 생각함', '숙고', '', 3],
  ['압권', '여러 책이나 작품 가운데 가장 잘된 책이나 작품', '백미', '', 3],
  ['판이', '비교 대상의 성질이나 모양, 상태 따위가 아주 다름', '상이', '', 3],
  ['만연', '전염병이나 나쁜 현상이 널리 퍼짐', '확산', '', 3, 'grow'],
  ['통념', '일반적으로 널리 통하는 개념', '상식', '', 3],
  ['확립', '체계나 견해, 조직 따위가 굳게 섬', '정립', '', 3],
  ['안목', '사물을 보고 분별하는 견식', '식견', '', 3],
  ['순탄', '삶 따위가 아무 탈 없이 순조로움', '평탄', '', 3],
  ['간헐', '얼마 동안의 시간 간격을 두고 되풀이하여 일어났다 그쳤다 함', '', '지속', 3, 'time'],
  ['융기', '땅이 기준면에 대하여 상대적으로 높아짐', '', '침강', 3],
  ['내포', '어떤 성질이나 뜻 따위를 속에 품음', '함축', '', 3],
];

// 사자성어: [성어, 뜻, 난이도, 묶음]
export const IDIOMS: [string, string, number, string?][] = [
  ['역지사지', '처지를 바꾸어 생각함', 1],
  ['일석이조', '한 가지 일로 두 가지 이익을 얻음', 1],
  ['자업자득', '자기가 저지른 일의 결과를 자기가 받음', 1, 'self'],
  ['결자해지', '일을 저지른 사람이 그 일을 해결해야 함', 2, 'self'],
  ['고진감래', '고생 끝에 즐거움이 옴', 1, 'fortune'],
  ['전화위복', '재앙이 바뀌어 오히려 복이 됨', 2, 'fortune'],
  ['새옹지마', '인생의 좋고 나쁨은 늘 바뀌어 미리 헤아리기 어려움', 2, 'fortune'],
  ['유비무환', '미리 준비가 되어 있으면 걱정할 것이 없음', 1],
  ['우유부단', '어물어물 망설이기만 하고 결단을 내리지 못함', 1],
  ['동문서답', '묻는 말에 전혀 엉뚱한 대답을 함', 1],
  ['일취월장', '나날이 다달이 자라거나 발전함', 2],
  ['주객전도', '사물의 가볍고 무거움이나 앞뒤의 차례가 서로 뒤바뀜', 2],
  ['침소봉대', '작은 일을 크게 부풀려 말함', 2],
  ['사필귀정', '모든 일은 반드시 바른길로 돌아감', 2],
  ['감언이설', '귀가 솔깃하도록 남의 비위를 맞추는 달콤한 말', 2],
  ['견물생심', '어떤 물건을 실제로 보게 되면 그것을 가지고 싶은 마음이 생김', 1],
  ['금상첨화', '좋은 일 위에 또 좋은 일이 더하여짐', 1],
  ['설상가상', '어려운 일이나 불행한 일이 잇따라 일어남', 1],
  ['다다익선', '많으면 많을수록 더욱 좋음', 1],
  ['과유불급', '정도를 지나침은 미치지 못함과 같음', 2],
  ['대기만성', '큰 사람이 되기 위해서는 많은 노력과 시간이 필요함', 2, 'effort'],
  ['오리무중', '무슨 일에 대하여 방향이나 갈피를 잡을 수 없음', 2],
  ['이심전심', '마음과 마음으로 서로 뜻이 통함', 1],
  ['작심삼일', '단단히 먹은 마음이 사흘을 가지 못함', 1],
  ['조삼모사', '눈앞의 차이만 알고 결과가 같은 것을 모르는 어리석음', 3],
  ['청출어람', '제자나 후배가 스승이나 선배보다 나음', 2],
  ['타산지석', '다른 사람의 하찮은 언행도 자기 수양에 도움이 될 수 있음', 2],
  ['토사구팽', '필요할 때는 쓰고 필요 없을 때는 야박하게 버림', 3],
  ['학수고대', '몹시 기다림', 2],
  ['호사다마', '좋은 일에는 흔히 방해되는 일이 많음', 3],
  ['반신반의', '얼마쯤 믿으면서도 한편으로는 의심함', 1],
  ['시기상조', '어떤 일을 하기에 아직 때가 이름', 2],
  ['우공이산', '어떤 일이든 끊임없이 노력하면 반드시 이루어짐', 3, 'effort'],
  ['아전인수', '자기에게만 이롭게 되도록 생각하거나 행동함', 2],
  ['와신상담', '원수를 갚거나 목적을 이루기 위하여 온갖 괴로움을 참고 견딤', 3, 'effort'],
  ['진퇴양난', '이러지도 저러지도 못하는 어려운 처지', 2],
  ['표리부동', '마음이 음흉하여 겉과 속이 다름', 2],
  ['각골난망', '남에게 입은 은혜가 뼈에 새길 만큼 커서 잊히지 아니함', 3],
  ['구사일생', '죽을 고비를 여러 차례 넘기고 겨우 살아남', 2],
  ['권선징악', '착한 일을 권장하고 악한 일을 징계함', 2],
];

export interface PassageQ { ask: string; right: string; wrong: string[] }
export interface Passage { title: string; level: number; text: string; qs: PassageQ[] }

// 설명하는 글 — 내용 일치 · 중심 내용 · 적용
export const PASSAGES: Passage[] = [
  {
    title: '잠과 기억', level: 1,
    text: '잠은 단순히 쉬는 시간이 아니다. 깨어 있는 동안 받아들인 정보는 잠을 자는 동안 다시 정리되어 오래 남는 기억으로 바뀐다. 특히 깊은 잠을 자는 동안 뇌는 낮에 익힌 내용을 되풀이하며 기억을 굳히는 것으로 알려져 있다. 그래서 시험 전날 밤을 새워 공부하면 공부한 시간은 늘어나도 오히려 기억에 남는 양은 줄어들 수 있다.',
    qs: [
      { ask: '글의 내용과 일치하는 것은?', right: '잠을 자는 동안 낮에 익힌 내용이 기억으로 굳어진다.', wrong: ['잠은 몸을 쉬게 할 뿐 기억과는 관계가 없다.', '밤을 새워 공부하면 기억에 남는 양이 반드시 늘어난다.', '기억은 얕은 잠을 잘 때만 정리된다.'] },
      { ask: '글의 중심 내용으로 가장 알맞은 것은?', right: '잠은 배운 내용을 기억으로 굳히는 데 중요하다.', wrong: ['시험 전에는 공부 시간을 최대한 늘려야 한다.', '깊은 잠과 얕은 잠은 번갈아 나타난다.', '기억력은 타고나는 것이라 바꿀 수 없다.'] },
    ],
  },
  {
    title: '기회비용', level: 2,
    text: '어떤 것을 선택하면 다른 것을 포기해야 한다. 이때 포기한 것들 가운데 가장 가치가 큰 것을 기회비용이라고 한다. 예를 들어 주말에 일당 10만 원짜리 아르바이트 대신 여행을 갔다면, 여행에 쓴 돈뿐 아니라 벌 수 있었던 10만 원도 여행의 비용에 들어간다. 따라서 합리적인 선택을 하려면 눈에 보이는 지출뿐 아니라 포기한 것의 가치까지 따져야 한다.',
    qs: [
      { ask: '글의 내용과 일치하는 것은?', right: '선택의 비용에는 포기한 것의 가치도 들어간다.', wrong: ['기회비용은 포기한 것 모두의 가치를 더한 것이다.', '여행의 비용은 여행에 쓴 돈뿐이다.', '눈에 보이는 지출만 따지는 것이 합리적인 선택이다.'] },
      { ask: '글에 따를 때, 시급 1만 원짜리 일을 3시간 쉬고 2만 원짜리 공연을 보았다면 공연의 비용은 모두 얼마인가? (다른 대안은 없다)', right: '5만 원', wrong: ['2만 원', '3만 원', '1만 원'] },
    ],
  },
  {
    title: '꿀벌의 춤', level: 3,
    text: '꿀벌은 춤으로 먹이가 있는 곳을 알린다. 먹이가 가까우면 원을 그리며 돌고, 멀면 8자 모양으로 돌면서 가운데에서 몸을 흔든다. 8자 춤에서 몸을 흔들며 나아가는 방향이 수직 위쪽과 이루는 각도는 태양을 기준으로 한 먹이의 방향을 나타내고, 몸을 흔드는 시간이 길수록 먹이가 멀리 있다는 뜻이다.',
    qs: [
      { ask: '글의 내용과 일치하는 것은?', right: '몸을 흔드는 시간으로 먹이까지의 거리를 알린다.', wrong: ['먹이가 가까울수록 8자 모양으로 춤을 춘다.', '춤의 방향은 벌집 입구를 기준으로 먹이 방향을 나타낸다.', '꿀벌은 먹이의 양을 춤의 속도로 알린다.'] },
      { ask: '8자 춤에서 몸을 흔들며 수직 위쪽으로 곧게 나아갔다면 먹이는 어디에 있는가?', right: '태양이 있는 쪽', wrong: ['태양의 반대쪽', '벌집 바로 옆', '글만으로는 알 수 없다'] },
    ],
  },
  {
    title: '단리와 복리', level: 3,
    text: '복리는 원금에서 생긴 이자를 원금에 더해 그다음 이자를 계산하는 방식이다. 반면 단리는 처음 원금에만 이자가 붙는다. 기간이 짧을 때는 두 방식의 차이가 작지만, 기간이 길어질수록 이자에 이자가 붙어 차이가 빠르게 커진다. 연 7%의 복리라면 원금이 두 배가 되는 데 약 10년이 걸린다.',
    qs: [
      { ask: '글의 내용과 일치하는 것은?', right: '기간이 길수록 복리와 단리의 차이가 커진다.', wrong: ['단리는 이자에도 이자가 붙는다.', '기간이 짧을수록 두 방식의 차이가 커진다.', '연 7% 복리라면 원금이 두 배가 되는 데 약 20년이 걸린다.'] },
      { ask: '원금 100만 원을 연 10% 단리로 2년 맡기면 받는 이자는 모두 얼마인가?', right: '20만 원', wrong: ['21만 원', '10만 원', '12만 원'] },
    ],
  },
  {
    title: '확증 편향', level: 4,
    text: '사람들은 자기가 이미 믿는 것을 뒷받침하는 정보는 쉽게 받아들이고, 반대되는 정보는 무시하거나 깎아내리는 경향이 있다. 이를 확증 편향이라고 한다. 확증 편향에 빠지면 정보를 많이 모을수록 오히려 잘못된 믿음이 더 단단해질 수 있다. 이를 줄이려면 내 생각이 틀렸다면 어떤 증거가 나와야 하는지를 먼저 정해 두고, 그 증거를 일부러 찾아보는 것이 도움이 된다.',
    qs: [
      { ask: '글의 내용과 일치하는 것은?', right: '정보를 많이 모아도 잘못된 믿음이 강해질 수 있다.', wrong: ['확증 편향은 반대 정보를 더 쉽게 받아들이는 경향이다.', '확증 편향은 정보를 많이 모으면 저절로 사라진다.', '자기 생각을 뒷받침하는 증거만 찾는 것이 해결책이다.'] },
      { ask: '확증 편향을 줄이는 행동으로 가장 알맞은 것은?', right: '투자하기 전에 이 종목이 실패할 이유를 먼저 찾아본다.', wrong: ['내 의견에 동의하는 기사만 골라 읽는다.', '처음 내린 판단을 끝까지 지킨다.', '반대 의견을 내는 사람과의 대화를 피한다.'] },
    ],
  },
  {
    title: '도시 열섬', level: 4,
    text: '도시의 기온이 주변 교외보다 높게 나타나는 현상을 열섬 현상이라고 한다. 아스팔트와 콘크리트는 낮에 열을 많이 흡수했다가 밤에 천천히 내보내고, 건물과 자동차, 냉방기에서도 열이 나온다. 반면 흙과 나무가 적어 물이 증발하며 열을 식히는 효과는 작다. 그래서 열섬 현상은 특히 밤에 뚜렷하며, 도시에 숲과 공원을 늘리면 이를 줄일 수 있다.',
    qs: [
      { ask: '글의 내용과 일치하는 것은?', right: '열섬 현상은 밤에 더 뚜렷하게 나타난다.', wrong: ['아스팔트는 낮에 흡수한 열을 바로 내보낸다.', '도시는 물의 증발로 식는 효과가 교외보다 크다.', '공원을 늘리면 열섬 현상이 심해진다.'] },
      { ask: '글의 중심 내용으로 가장 알맞은 것은?', right: '도시가 교외보다 더운 까닭과 이를 줄이는 방법', wrong: ['아스팔트를 만드는 방법', '냉방기가 작동하는 원리', '교외의 기온이 높아지는 까닭'] },
    ],
  },
  {
    title: '손실 회피', level: 5,
    text: '사람들은 같은 크기라도 얻는 것보다 잃는 것을 더 크게 느낀다. 여러 실험에서 사람들은 잃을 확률과 얻을 확률이 반반인 내기에서, 얻는 돈이 잃는 돈의 두 배쯤은 되어야 내기에 응했다. 이를 손실 회피라고 한다. 손실 회피 때문에 사람들은 손해를 본 주식을 팔지 못하고 붙들고 있거나, 이미 가진 물건을 실제 가치보다 높게 평가하기도 한다.',
    qs: [
      { ask: '글의 내용과 일치하는 것은?', right: '사람들은 잃는 것을 같은 크기의 얻는 것보다 크게 느낀다.', wrong: ['반반 내기에서 사람들은 얻는 돈이 잃는 돈과 같으면 기꺼이 응했다.', '손실 회피 때문에 사람들은 손해 본 주식을 빨리 판다.', '사람들은 가진 물건을 실제보다 낮게 평가한다.'] },
      { ask: '글에 따르면 반반 확률로 1만 원을 잃을 수 있는 내기에 사람들이 응하려면, 이길 때 받는 돈이 대략 얼마여야 하는가?', right: '2만 원', wrong: ['5천 원', '1만 원', '10만 원'] },
    ],
  },
  {
    title: '훈민정음의 원리', level: 5,
    text: '훈민정음의 자음은 소리를 낼 때 발음 기관의 모양을 본떠 만들었다. ㄱ은 혀뿌리가 목구멍을 막는 모양, ㄴ은 혀끝이 윗잇몸에 닿는 모양, ㅁ은 입 모양, ㅅ은 이의 모양, ㅇ은 목구멍의 모양을 본떴다. 그리고 소리가 세지는 정도에 따라 획을 더해 ㅋ, ㄷ, ㅌ, ㅂ, ㅍ 같은 글자를 만들었다. 모음은 하늘(·), 땅(ㅡ), 사람(ㅣ)을 본뜬 세 글자를 바탕으로 이들을 합쳐 만들었다.',
    qs: [
      { ask: '글의 내용과 일치하는 것은?', right: 'ㅋ은 ㄱ에 획을 더해 만든 글자이다.', wrong: ['모음은 발음 기관의 모양을 본떠 만들었다.', 'ㅁ은 이의 모양을 본떴다.', '자음은 하늘, 땅, 사람을 본떠 만들었다.'] },
      { ask: '글에 따를 때 ㅂ의 바탕이 된 기본 글자는?', right: 'ㅁ', wrong: ['ㄱ', 'ㄴ', 'ㅅ'] },
    ],
  },
  {
    title: '간격 효과', level: 6,
    text: '한 번에 몰아서 공부하는 것보다 같은 시간을 여러 날에 나누어 공부할 때 더 오래 기억한다. 이를 간격 효과라고 한다. 시간이 지나 조금 잊어버릴 무렵에 다시 떠올리려고 애쓰는 과정이 기억을 더 단단하게 만들기 때문이다. 또 다시 볼 때 답을 바로 보기보다 먼저 스스로 떠올려 보는 것이 효과가 더 크다.',
    qs: [
      { ask: '글의 내용과 일치하는 것은?', right: '나누어 공부하면 몰아서 공부할 때보다 오래 기억한다.', wrong: ['잊어버리기 전에 쉬지 않고 계속 반복해서 보는 것이 가장 좋다.', '복습할 때는 답을 먼저 보는 것이 효과가 크다.', '간격 효과는 공부 시간이 길수록 사라진다.'] },
      { ask: '간격 효과를 가장 잘 이용한 계획은?', right: '월·수·금에 30분씩 공부하고, 볼 때마다 먼저 떠올려 본다.', wrong: ['시험 전날 3시간 동안 몰아서 읽는다.', '같은 날 30분씩 세 번 연달아 읽는다.', '답과 해설을 여러 번 눈으로 훑어본다.'] },
    ],
  },
  {
    title: '공유지의 비극', level: 6,
    text: '누구나 쓸 수 있는 목초지가 있다고 하자. 목동은 저마다 소를 한 마리 더 풀어 놓을수록 자기 이익이 늘지만, 풀이 줄어드는 피해는 모두가 나누어 진다. 그래서 각자 자기에게 이로운 선택을 하면 결국 목초지가 황폐해져 모두가 손해를 본다. 이를 공유지의 비극이라고 한다. 이를 막기 위해 사용량을 정하는 규칙을 만들거나, 소유권을 나누거나, 공동체가 스스로 감시하는 방법이 쓰인다.',
    qs: [
      { ask: '글의 내용과 일치하는 것은?', right: '개인에게 이로운 선택이 모두에게 손해가 될 수 있다.', wrong: ['소를 더 풀어 놓은 목동만 피해를 입는다.', '공유지의 비극은 규칙으로 막을 수 없다.', '목동들은 목초지를 아끼려고 스스로 소를 줄인다.'] },
      { ask: '공유지의 비극의 예로 가장 알맞은 것은?', right: '누구나 고기를 잡을 수 있는 바다에서 물고기가 줄어든다.', wrong: ['가게 주인이 자기 가게를 깨끗이 청소한다.', '친구끼리 돈을 모아 선물을 산다.', '회사가 신제품 가격을 올린다.'] },
    ],
  },
];
